var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["facets/category-facets-mobile.j2"] = require( "facets/category-facets-mobile.j2" );
dependencies["facets/category-facet-panels-mobile.j2"] = require( "facets/category-facet-panels-mobile.j2" );
dependencies["facets/category-size-group-facet.j2"] = require( "facets/category-size-group-facet.j2" );
dependencies["facets/category-price-facet.j2"] = require( "facets/category-price-facet.j2" );
dependencies["facets/category-color-facet.j2"] = require( "facets/category-color-facet.j2" );
dependencies["facets/category-default-facet.j2"] = require( "facets/category-default-facet.j2" );
dependencies["category-more-refinements.j2"] = require( "category-more-refinements.j2" );
dependencies["facets/category-facets-reset.j2"] = require( "facets/category-facets-reset.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-facets-outer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"nav")) > 0) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
env.getTemplate("facets/category-facets-mobile.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
env.getTemplate("facets/category-facet-panels-mobile.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
})})})});
}
else {
output += "<div class=\"u-extra-small--show u-medium--hide\">\n        <h3>\n            ";
output += runtime.suppressValue((lineno = 20, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-small-label"])), env.opts.autoescape);
output += "\n            <span>";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets")) {
output += runtime.suppressValue((lineno = 23, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-applied-count",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets")]})])), env.opts.autoescape);
output += "\n            ";
;
}
output += "</span>\n        </h3>\n    </div>\n\n    <div class=\"c-facets\">\n\n        <h3 class=\"c-category-navigation__heading\">\n\n            ";
output += runtime.suppressValue((lineno = 33, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-navigation-heading"])), env.opts.autoescape);
output += "\n\n        </h3>\n\n        <div class=\"o-accordion c-facets-accordion js-accordion js-facets-accordion\" role=\"tablist\" aria-multiselectable=\"true\">";
frame = frame.push();
var t_11 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"nav");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("navItem", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
if(env.getFilter("length").call(context, runtime.memberLookup((t_12),"refinements")) > 0) {
if(env.getFilter("length").call(context, runtime.memberLookup((t_12),"refinements")) % 2) {
var t_13;
t_13 = "s-two-column-facets--odd";
frame.set("evenOrOddClass", t_13, true);
if(frame.topLevel) {
context.setVariable("evenOrOddClass", t_13);
}
if(frame.topLevel) {
context.addExport("evenOrOddClass", t_13);
}
;
}
else {
var t_14;
t_14 = "s-two-column-facets--even";
frame.set("evenOrOddClass", t_14, true);
if(frame.topLevel) {
context.setVariable("evenOrOddClass", t_14);
}
if(frame.topLevel) {
context.addExport("evenOrOddClass", t_14);
}
;
}
if(runtime.memberLookup((t_12),"selected") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"ab")),"SS_FILTERSET") == 2) {
var t_15;
t_15 = "is-expanded";
frame.set("accordionTabState", t_15, true);
if(frame.topLevel) {
context.setVariable("accordionTabState", t_15);
}
if(frame.topLevel) {
context.addExport("accordionTabState", t_15);
}
;
}
else {
var t_16;
t_16 = "is-collapsed";
frame.set("accordionTabState", t_16, true);
if(frame.topLevel) {
context.setVariable("accordionTabState", t_16);
}
if(frame.topLevel) {
context.addExport("accordionTabState", t_16);
}
;
}
var t_17;
t_17 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"showTwoColumnFiltersDesktop");
frame.set("showTwoColumnFiltersDesktop", t_17, true);
if(frame.topLevel) {
context.setVariable("showTwoColumnFiltersDesktop", t_17);
}
if(frame.topLevel) {
context.addExport("showTwoColumnFiltersDesktop", t_17);
}
var t_18;
t_18 = runtime.memberLookup((runtime.memberLookup((t_12),"metaDetails")),"showTwoColumnFilters");
frame.set("showTwoColumnFilters", t_18, true);
if(frame.topLevel) {
context.setVariable("showTwoColumnFilters", t_18);
}
if(frame.topLevel) {
context.addExport("showTwoColumnFilters", t_18);
}
var t_19;
t_19 = runtime.memberLookup(((lineno = 66, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.facetOptions.selectedFacetCountByName",{}]))),runtime.memberLookup((t_12),"name"));
frame.set("selectedFacetCountByName", t_19, true);
if(frame.topLevel) {
context.setVariable("selectedFacetCountByName", t_19);
}
if(frame.topLevel) {
context.addExport("selectedFacetCountByName", t_19);
}
var t_20;
t_20 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("loopIndex", t_20, true);
if(frame.topLevel) {
context.setVariable("loopIndex", t_20);
}
if(frame.topLevel) {
context.addExport("loopIndex", t_20);
}
output += "\n\n                    <div class=\"o-accordion__tabset c-facets-accordion__tabset js-accordion-tabset ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "accordionTabState"), env.opts.autoescape);
output += "\" data-accordion-tab-name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "\" data-qa-";
output += runtime.suppressValue(env.getFilter("lower").call(context, env.getFilter("sanitize_attr").call(context, runtime.memberLookup((t_12),"displayName"))), env.opts.autoescape);
output += "-filter>\n\n                        <a href=\"#o-accordion__tab--filter-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loopIndex"), env.opts.autoescape);
output += "\" id=\"o-accordion__tab--filter-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loopIndex"), env.opts.autoescape);
output += "\" class=\"o-accordion__tab c-facets-accordion__tab js-accordion-tab\"  aria-selected=\"false\" aria-controls=\"o-accordion__panel--filter-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loopIndex"), env.opts.autoescape);
output += "\" aria-expanded=\"false\" role=\"tab\" data-accordion-title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"displayName"), env.opts.autoescape);
output += "\">\n\n                            <h4 class=\"o-accordion__label c-facets__h4\">\n                                ";
output += runtime.suppressValue((lineno = 74, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["catalog_facets-" + "" + env.getFilter("lower").call(context, env.getFilter("sanitize_attr").call(context, runtime.memberLookup((t_12),"displayName")))])), env.opts.autoescape);
output += "\n\n                                ";
if(runtime.contextOrFrameLookup(context, frame, "selectedFacetCountByName") && runtime.contextOrFrameLookup(context, frame, "selectedFacetCountByName") > 0) {
output += "\n                                    <span class=\"c-facets__count\" data-qa-facet-count>";
output += runtime.suppressValue((lineno = 77, colno = 88, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets_selected_count_drawer",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "selectedFacetCountByName")]})])), env.opts.autoescape);
output += "</span>\n                                ";
;
}
output += "\n                            </h4>\n\n                            <span class=\"o-accordion__control c-facets-accordion__control\" aria-label=\"";
output += runtime.suppressValue((lineno = 81, colno = 105, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["accordion-tooltip_expand"])), env.opts.autoescape);
output += "\" data-qa-expand-accordion></span>\n\n                        </a>\n\n                        <div id=\"o-accordion__panel--filter-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loopIndex"), env.opts.autoescape);
output += "\" class=\"";
if(runtime.contextOrFrameLookup(context, frame, "showTwoColumnFiltersDesktop") && runtime.contextOrFrameLookup(context, frame, "showTwoColumnFilters")) {
output += "s-two-column-facets ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "evenOrOddClass"), env.opts.autoescape);
;
}
output += " o-accordion__panel c-facets-accordion__panel js-accordion-panel ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "accordionTabState"), env.opts.autoescape);
output += "\" aria-labelledby=\"o-accordion__tab--filter-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loopIndex"), env.opts.autoescape);
output += "\" aria-hidden=\"true\" role=\"tabpanel\">";
if(runtime.memberLookup((t_12),"name") == "visualVariants.nonvisualVariants.sizeClassGroups") {
env.getTemplate("facets/category-size-group-facet.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
})});
}
else {
output += "<ul data-facet-name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "\" class=\"o-row c-facet__ul c-facet__ul--";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.memberLookup((t_12),"displayName")), env.opts.autoescape);
output += "\" data-qa-facet-name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "\">";
var t_25;
t_25 = false;
frame.set("onlyShowSelected", t_25, true);
if(frame.topLevel) {
context.setVariable("onlyShowSelected", t_25);
}
if(frame.topLevel) {
context.addExport("onlyShowSelected", t_25);
}
var t_26;
t_26 = runtime.memberLookup((runtime.memberLookup((t_12),"metaDetails")),"showResultsCount");
frame.set("showResultsCount", t_26, true);
if(frame.topLevel) {
context.setVariable("showResultsCount", t_26);
}
if(frame.topLevel) {
context.addExport("showResultsCount", t_26);
}
if(runtime.memberLookup((t_12),"name") == "visualVariants.nonvisualVariants.salePrice") {
env.getTemplate("facets/category-price-facet.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
})});
}
else {
if(runtime.memberLookup((t_12),"name") == "visualVariants.colorwayNames") {
env.getTemplate("facets/category-color-facet.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
})});
}
else {
if(runtime.memberLookup((t_12),"name") == "tile.product.brand") {
env.getTemplate("facets/category-default-facet.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_37,t_35) {
if(t_37) { cb(t_37); return; }
t_35.render(context.getVariables(), frame, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
output += t_36
})});
}
else {
env.getTemplate("facets/category-default-facet.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_41,t_39) {
if(t_41) { cb(t_41); return; }
t_39.render(context.getVariables(), frame, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
output += t_40
})});
}
;
}
;
}
output += "</ul>";
;
}
if(runtime.memberLookup((t_12),"moreRefinements")) {
env.getTemplate("category-more-refinements.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_45,t_43) {
if(t_45) { cb(t_45); return; }
t_43.render(context.getVariables(), frame, function(t_46,t_44) {
if(t_46) { cb(t_46); return; }
output += t_44
})});
}
output += "</div>\n\n                    </div>";
;
}
;
}
}
frame = frame.pop();
output += "</div>\n\n        ";
output += "\n        ";
env.getTemplate("facets/category-facets-reset.j2", false, "category/templates/facets/category-facets-outer.j2", null, function(t_49,t_47) {
if(t_49) { cb(t_49); return; }
t_47.render(context.getVariables(), frame, function(t_50,t_48) {
if(t_50) { cb(t_50); return; }
output += t_48
output += "\n\n    </div>";
})});
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-facets-outer.j2"] , dependencies)